export type QcCorrectionLine = {
  observation_id: string;
  item_id: string | null;
  category: string;
  title: string;
  failure_note: string;
  action: string;
};

export type QcCorrection = {
  parent_session_id: string;
  lines: QcCorrectionLine[];
};

export function readQcCorrection(summary: Record<string, unknown> | null | undefined): QcCorrection | null {
  const raw = summary?.correction;
  if (!raw || typeof raw !== "object") return null;
  const row = raw as Record<string, unknown>;
  const parent = typeof row.parent_session_id === "string" ? row.parent_session_id : "";
  if (!parent) return null;
  const lines = Array.isArray(row.lines)
    ? row.lines.flatMap((item) => {
        if (!item || typeof item !== "object") return [];
        const line = item as Record<string, unknown>;
        const observationId = typeof line.observation_id === "string" ? line.observation_id : "";
        if (!observationId) return [];
        return [{
          observation_id: observationId,
          item_id: typeof line.item_id === "string" ? line.item_id : null,
          category: typeof line.category === "string" ? line.category : "QC defect",
          title: typeof line.title === "string" ? line.title : "QC defect",
          failure_note: typeof line.failure_note === "string" ? line.failure_note : "",
          action: typeof line.action === "string" ? line.action : "",
        }];
      })
    : [];
  return { parent_session_id: parent, lines };
}
